/**
 * Arkius Certification Kickstarter API
 * Arkius PBC API v5.2026.1012.0845
 *
 * The version of the OpenAPI document: v1
 * Contact: info@arkius.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderBy } from './orderBy';


/**
 * SearchFilterModel
 */
export interface SearchFilterModel { 
    pageNumber?: number;
    pageSize?: number;
    SearchStr?: string | null;
    OrderBy?: OrderBy;
    /**
     * Gets or sets the certification category ids.
     */
    CertificationCategoryIds?: Array<number> | null;
    /**
     * Gets or sets a value indicating whether this ACK.Api.ViewModels.Certification.SearchFilterModel is liked.
     */
    Liked?: boolean | null;
    /**
     * Get all entity categories
     */
    EntityCategoryIds?: Array<number> | null;
}

